/**
 * Next Drop Countdown - Moon Moon Agency
 * Handles the countdown timer(s) in MM-Next-Drop section and the
 * "drop" breaking block of the collection grid — supports multiple
 * independent instances on the same page.
 */

/*********************************************************************************************
 * ⏱ NEXT DROP COUNTDOWN MANAGER
 */
const NextDropCountdownManager = {
    config: {
        selectors: {
            wrapper: '[data-next-drop-countdown]',
            days: '[data-countdown-days]',
            hours: '[data-countdown-hours]',
            minutes: '[data-countdown-minutes]',
            cta: '[data-next-drop-cta]',
        },
    },

    init() {
        const wrappers = window.getElements(this.config.selectors.wrapper);
        if (!wrappers.length) return;

        wrappers.forEach((wrapper) => this._initWrapper(wrapper));
    },

    _initWrapper(wrapper) {
        const endAttr = wrapper.dataset.end;
        if (!endAttr) return;

        const endDate = new Date(endAttr);
        if (isNaN(endDate.getTime())) {
            window.log('warn', '⏱ [NEXT_DROP]', 'Invalid end date', { endAttr });
            return;
        }

        let startDate = null;
        const startAttr = wrapper.dataset.start;
        if (startAttr) {
            const parsedStart = new Date(startAttr);
            if (isNaN(parsedStart.getTime())) {
                window.log('warn', '⏱ [NEXT_DROP]', 'Invalid start date', { startAttr });
            } else {
                startDate = parsedStart;
            }
        }

        this._tick(wrapper, startDate, endDate);
        this._interval = setInterval(() => this._tick(wrapper, startDate, endDate), 60000);

        window.log('info', '⏱ [NEXT_DROP]', 'Initialized', { startDate, endDate });
    },

    _tick(wrapper, startDate, endDate) {
        const now = new Date();
        const cta = window.getElement(this.config.selectors.cta);

        if (startDate && now < startDate) {
            wrapper.hidden = true;
            if (cta) cta.hidden = true;
            return;
        }

        const diff = endDate - now;

        if (diff <= 0) {
            clearInterval(this._interval);
            wrapper.hidden = true;
            if (cta) cta.hidden = false;
            return;
        }

        wrapper.hidden = false;
        if (cta) cta.hidden = true;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        const daysEl = wrapper.querySelector(this.config.selectors.days);
        const hoursEl = wrapper.querySelector(this.config.selectors.hours);
        const minutesEl = wrapper.querySelector(this.config.selectors.minutes);

        if (daysEl) daysEl.textContent = days;
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    },
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => NextDropCountdownManager.init());
} else {
    NextDropCountdownManager.init();
}
